import urlSlug from "url-slug";
import data from "../.sourceflow/consultants.json";

// Collection values are stored per locale ({ en: value }) — flatten to a plain value
const localise = (value) =>
  value && typeof value === "object" && !Array.isArray(value) && "en" in value ? value.en : value;

const normaliseConsultant = (consultant) => ({
  id: consultant?.id,
  url_slug: consultant?.url_slug,
  name: localise(consultant?.name),
  image: localise(consultant?.image),
  email: localise(consultant?.email),
  telephone: localise(consultant?.telephone),
  linkedin: localise(consultant?.linkedin),
  position: localise(consultant?.position),
});

const consultants = (data?.category_values ?? []).map(normaliseConsultant);

export const getConsultants = () => consultants;

export const useConsultants = () => consultants;

// The campaign blogs author is a category link to Consultants, the news one is free text,
// so match on whichever identifiers we are handed: object, id, url_slug or name.
export const findConsultant = (author) => {
  const value = localise(author);

  if (!value) {
    return null;
  }

  const identifiers = (
    typeof value === "object" ? [value.id, value.url_slug, localise(value.name)] : [value]
  ).filter(Boolean);

  if (identifiers.length === 0) {
    return null;
  }

  const slugs = identifiers.map((identifier) => urlSlug(String(identifier).toLowerCase()));

  return (
    consultants.find(
      (consultant) =>
        identifiers.includes(consultant.id) ||
        slugs.includes(consultant.url_slug) ||
        slugs.includes(urlSlug(String(consultant.name ?? "").toLowerCase()))
    ) ?? null
  );
};

export default useConsultants;
